

export const styles = {
  
  containerPrincipal: {
    width: "15vw",
    height: "5vh",
    //margin: "0 auto" ,
    //padding: "6px 6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center", 
    //gap: "2%",
    //border: "1px solid rgba(0, 136, 194, 0.4)",
    //borderRadius: "25px",
    //boxSizing: "border-box",

  },

  barraExterna: {
    width: "50%",
    height: "22px",
    background: "var(--input-bg)",
    borderRadius: "10px",
    overflow: "hidden",
    position: "relative",
  },

  barraInterna: {
    height: "100%",
    background: "linear-gradient(135deg, var(--accent) 0%, var(--accent-secondary) 100%)",
    transition: "width 0.4s ease",
  },

  textoCentral: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    fontSize: "13px",
    color: "var(--text-on-accent)",
    textShadow: "0 1px 2px var(--surface-overlay)",
  },
};